<template>
  <div>
    <BodyLoader :loading="firstLoad"></BodyLoader>

    <MemberHeaderNav
      v-if="id != 'all'"
      :member="member"
      :summary="summary"
      :team="team"
      @filterByReferralStatus="filterByReferralStatus"></MemberHeaderNav>

    <div class="row dvContent forMember">

      <div class="col s12 dvContentMain">
        <div class="dvSectionTitleOpts">
          <div class="dvSectionTitleOpts-title">
            <span class="icon-fs_referrals"></span>Resolve Pending
          </div> <!-- dvSectionTitleOpts-title -->
        </div> <!-- dvSectionTitleOpts -->

        <div
          v-show="noRecordFound && !loadingConflict"
          class="dvBlankSection">
          <div class="dvBlankSectionBox flexCenterAll">
            <div class="dvBlankSection-content">
              <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
              <div class="dvBlankSection-text-primary center-align">
                There are no duplicates to display
              </div>
              <div class="dvBlankSection-text-secondary center-align">
                Try using the search box above to find what you are looking for.
              </div>
            </div>
          </div>
        </div>


        <!-- <ContentLoader :loading="loadingConflict" :firstLoad="firstLoad"></ContentLoader> -->

        <!-- <div
          v-show="loadingConflict"
          class="dvBlankSection">
          <div class="dvBlankSectionBox flexCenterAll">
            <div class="dvBlankSection-content">
              <div class="dvBlankSection-text-primary center-align">
                Please wait...
              </div>
            </div>
          </div>
        </div> -->

        <div class="dvResolve" v-if="hasConflict && !loadingConflict">
          <table>
            <thead class="dvResolve-head">
              <tr class="dvResolve-head-top">
                <th class="dvResolve-size-fixed"></th>
                <th class="dvResolve-size-cell isPrimary">{{ owner.archived == 1 ? 'Inactive Client' : 'Current Owner' }}</th>
                <th
                  v-for="(conflict, index) in conflicts" :key="index"
                  class="dvResolve-size-cell">
                  {{ (owner.archived == 1 && ownerReferrer.id == conflict.referred_by) ? 'Repeat Registration' : 'Duplicate ' + getDupIndex(index) +' of ' + (conflicts.length - getTotalRepeatReg()) }}
                </th>
              </tr> <!-- dvResolve-head-top -->
              <tr class="dvResolve-head-info">
                <th v-if="owner.archived == 0">Client has<br /><strong>{{ conflicts.length }} pending duplicate{{ conflicts.length > 1 ? 's' : '' }}</strong>for review <span class="icon-nav_link_right"></span></th>
                <th v-if="owner.archived == 1">
                  Client has<br><strong v-if="getTotalRepeatReg() > 0">a repeat registration{{ getTotalRepeatReg() > 1 ? 's' : '' }}</strong>
                  {{ getTotalRepeatReg() > 0 ? 'and' : '' }} <strong>{{ (conflicts.length - getTotalRepeatReg()) }} duplicate{{ (conflicts.length-getTotalRepeatReg()) > 1 ? 's' : '' }}</strong>for review <span class="icon-nav_link_right"></span></th>
                <th class="isPrimary">
                  <div class="dvResolve-user">
                    <div class="dvQuickGlance-image">
                      <div class="dvQuickGlance-image-placer flexCenterAll"><span class="icon-fs_user"></span></div>
                    </div> <!-- dvQuickGlance-image -->
                    <div class="dvResolve-user-name">{{ $store.getters.formatFullName(ownerReferrer.first_name, ownerReferrer.last_name) || ownerReferrer.email }}</div>
                    <div class="dvResolve-user-position">{{ ownerReferrer.position }}</div>
                    <div class="dvResolve-user-team">{{ ownerTeam.channel }} - {{ ownerTeam.team }}</div>
                    <div class="dvResolve-user-manager">Manager: <strong>{{ ownerTeam.manager }}</strong></div>
                    <a :href="'mailto:'+ownerReferrer.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                  </div> <!-- dvResolve-user -->
                </th>
                <th v-for="(conflict, index) in conflicts" :key="index">
                  <div
                    class="dvResolve-user">
                    <div class="dvQuickGlance-image">
                      <div class="dvQuickGlance-image-placer flexCenterAll"><span class="icon-fs_user"></span></div>
                      <!-- <img class="dvQuickGlance-image-pic responsive-img" src="assets/images/temp-user.jpg"> -->
                    </div> <!-- dvQuickGlance-image -->

                    <div class="dvResolve-user-name">{{ conflict.referrer.first_name.length > 0 ? $store.getters.formatFullName(conflict.referrer.first_name, conflict.referrer.last_name) : conflict.referrer.email }}</div>
                    <div class="dvResolve-user-position">{{ conflict.referrer.position }}</div>
                    <div class="dvResolve-user-team">{{ conflict.team.channel }} - {{ conflict.team.team }}</div>
                    <div class="dvResolve-user-manager">Manager: <strong>{{ conflict.team.manager }}</strong></div>
                    <a :href="'mailto:'+conflict.referrer.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                  </div> <!-- dvResolve-user -->
                </th>
              </tr>  <!-- dvResolve-head-info -->
            </thead> <!-- dvResolve-head -->
            <tbody>
              <tr class="dvResolve-section">
                <td :colspan="conflicts.length+2">
                  Client Information
                </td>
              </tr>
              <tr>
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_activity"></span>
                    <div class="dvResolve-label-text">Date / Time added</div>
                  </div>
                </td>
                <td>{{ owner.client_info.date_submitted | moment("MM/DD/YY") }} at {{ owner.client_info.date_submitted | moment("hh:mm A") }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.client_info.date_submitted | moment("MM/DD/YY") }} at {{ conflict.client_info.date_submitted | moment("hh:mm A") }}</td>
              </tr>
              <tr class="lastNameHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Last name</div>
                  </div>
                </td>
                <td>{{ capitalize(owner.client_info.last_name) }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ capitalize(conflict.client_info.last_name) }}</td>
              </tr>
              <tr class="firstNameHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">First name</div>
                  </div>
                </td>
                <td>{{ capitalize(owner.client_info.first_name) }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ capitalize(conflict.client_info.first_name) }}</td>
              </tr>
              <tr class="emailHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_email"></span>
                    <div class="dvResolve-label-text">Email</div>
                  </div>
                </td>
                <td><a :href="'mailto:'+owner.client_info.email">{{ owner.client_info.email }}</a></td>
                <td v-for="(conflict, index) in conflicts" :key="index"><a :href="'mailto:'+conflict.client_info.email">{{ conflict.client_info.email }}</a></td>
              </tr>
              <tr class="mobileHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_mobile"></span>
                    <div class="dvResolve-label-text">Mobile Number</div>
                  </div>
                </td>
                <td><a v-if="owner.client_info.extracted_mobile_no" :href="'tel:'+owner.client_info.extracted_mobile_no">{{ owner.client_info.extracted_mobile_no }}</a></td>
                <td v-for="(conflict, index) in conflicts" :key="index"><a v-if="conflict.client_info.extracted_mobile_no" :href="'tel:'+conflict.client_info.extracted_mobile_no">{{ conflict.client_info.extracted_mobile_no }}</a></td>
              </tr>
              <tr class="phoneHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_telephone"></span>
                    <div class="dvResolve-label-text">Phone Number</div>
                  </div>
                </td>
                <td><a v-if="owner.client_info.phone_no" :href="'tel:'+owner.client_info.phone_no">{{ owner.client_info.phone_no }}</a></td>
                <td v-for="(conflict, index) in conflicts" :key="index"><a v-if="conflict.client_info.phone_no" :href="'tel:'+conflict.client_info.phone_no">{{ conflict.client_info.phone_no }}</a></td>
              </tr>
              <tr class="bdayHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_calendar"></span>
                    <div class="dvResolve-label-text">Birthdate</div>
                  </div>
                </td>
                <td>{{ owner.client_info.birthdate == '0000-00-00' ? '' : owner.client_info.birthdate | moment("MM/DD/YYYY") }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.client_info.birthdate == '0000-00-00' ? '' : conflict.client_info.birthdate | moment("MM/DD/YYYY") }}</td>
              </tr>
              <tr class="countryHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_location"></span>
                    <div class="dvResolve-label-text">Country</div>
                  </div>
                </td>
                <td>{{ owner.client_info.country_name }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.client_info.country_name }}</td>
              </tr>

              <template
                v-for="(project, index) in projects">
                <tr class="dvResolve-section" v-bind:key="index">
                  <td :colspan="conflicts.length+2">
                    Project Inquiry {{ projects.length > 0 ? index + 1 : '' }}
                  </td>
                </tr>

                <ProjectInq
                  v-for="(proj, propertyName) in project" :key="index+propertyName"
                  :proj="proj"
                  :idx="index"
                  :propertyName="propertyName">
                </ProjectInq>
              </template> <!-- col -->


              <tr class="dvResolve-section personalInfoHeader">
                <td :colspan="conflicts.length+2">
                  Personal Information
                </td>
              </tr>
              <tr class="mothersMaindenHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Mother's Maiden Name</div>
                  </div>
                </td>
                <td>{{ owner.personal_info.mothers_maiden_name }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.personal_info.mothers_maiden_name }}</td>
              </tr>
              <tr class="companyNameHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_office"></span>
                    <div class="dvResolve-label-text">Company Name</div>
                  </div>
                </td>
                <td>{{ owner.personal_info.company_name }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.personal_info.company_name }}</td>
              </tr>
              <tr class="occupationHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-content_work"></span>
                    <div class="dvResolve-label-text">Occupation</div>
                  </div>
                </td>
                <td>{{ owner.personal_info.occupation }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.personal_info.occupation }}</td>
              </tr>
              <tr class="civilStatHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-nav_chevron_right"></span>
                    <div class="dvResolve-label-text">Civil Status</div>
                  </div>
                </td>
                <td>{{ owner.personal_info.civil_status }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.personal_info.civil_status }}</td>
              </tr>
              <tr class="homeOwnershipHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-nav_chevron_right"></span>
                    <div class="dvResolve-label-text">Home Ownership</div>
                  </div>
                </td>
                <td>{{ owner.personal_info.home_ownership }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.personal_info.home_ownership }}</td>
              </tr>
              <tr class="monthlyIncomeHeader">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-nav_chevron_right"></span>
                    <div class="dvResolve-label-text">Monthly Household Income</div>
                  </div>
                </td>
                <td>{{ owner.personal_info.monthly_income }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.personal_info.monthly_income }}</td>
              </tr>

              <tr class="dvResolve-section homeAddHeader">
                <td :colspan="conflicts.length+2">
                  HOME ADDRESS
                </td>
              </tr>
              <tr class="homeAdd1">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Address 1</div>
                  </div>
                </td>
                <td>{{ owner.home_address.address1 }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.home_address.address1 }}</td>
              </tr>
              <tr class="homeAdd2">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Address 2</div>
                  </div>
                </td>
                <td>{{ owner.home_address.address2 }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.home_address.address2 }}</td>
              </tr>
              <tr class="homeCity">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">City</div>
                  </div>
                </td>
                <td>{{ owner.home_address.city }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.home_address.city }}</td>
              </tr>
              <tr class="homeState">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">State / Province</div>
                  </div>
                </td>
                <td>{{ owner.home_address.state_province }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.home_address.state_province }}</td>
              </tr>
              <tr class="homeZipCode">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Zip Code</div>
                  </div>
                </td>
                <td>{{ owner.home_address.zip_code }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.home_address.zip_code }}</td>
              </tr>
              <tr class="homeCountry">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Country</div>
                  </div>
                </td>
                <td>{{ owner.home_address.country_name }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.home_address.country_name }}</td>
              </tr>

              <tr class="dvResolve-section officeAddHeader">
                <td :colspan="conflicts.length+2">
                  Office ADDRESS
                </td>
              </tr>
              <tr class="officeAdd1">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Address 1</div>
                  </div>
                </td>
                <td>{{ owner.office_address.address1 }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.office_address.address1 }}</td>
              </tr>
              <tr class="officeAdd2">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Address 2</div>
                  </div>
                </td>
                <td>{{ owner.office_address.address2 }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.office_address.address2 }}</td>
              </tr>
              <tr class="officeCity">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">City</div>
                  </div>
                </td>
                <td>{{ owner.office_address.city }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.office_address.city }}</td>
              </tr>
              <tr class="officeState">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">State / Province</div>
                  </div>
                </td>
                <td>{{ owner.office_address.state_province }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.office_address.state_province }}</td>
              </tr>
              <tr class="officeZipCode">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Zip Code</div>
                  </div>
                </td>
                <td>{{ owner.office_address.zip_code }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.office_address.zip_code }}</td>
              </tr>
              <tr class="officeCountry">
                <td>
                  <div class="dvResolve-label">
                    <span class="icon-fs_user"></span>
                    <div class="dvResolve-label-text">Country</div>
                  </div>
                </td>
                <td>{{ owner.office_address.country_name }}</td>
                <td v-for="(conflict, index) in conflicts" :key="index">{{ conflict.office_address.country_name }}</td>
              </tr>
              <tr class="forAction">
                <td></td>
                <td>
                  <a
                    v-if="owner.archived == 0"
                    @click="confirm({
                      id: owner.id,
                      name: $store.getters.formatFullName(ownerReferrer.first_name, ownerReferrer.last_name),
                      type: 'confirm'
                    })"
                    href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners isPrimary"><span class="icon-action_check_circle"></span><div class="label">Confirm</div></a>

                  <a
                    v-if="owner.archived == 1"
                    @click="confirm({
                      id: owner.id,
                      name: $store.getters.formatFullName(ownerReferrer.first_name, ownerReferrer.last_name),
                      type: 'deny'
                    })"
                    href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners isPrimary bgPending"><span class="icon-action_close"></span><div class="label">Deny</div></a>
                </td>
                <td v-for="(conflict, index) in conflicts" :key="index">

                  <a
                    v-if="owner.archived == 0"
                    @click="confirm({
                      id: conflict.id,
                      name: $store.getters.formatFullName(conflict.referrer.first_name, conflict.referrer.last_name),
                      type: 'reassign'
                    })"
                    href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners"><span class="icon-action_check_circle"></span><div class="label">Reassign</div></a>

                  <a
                    v-if="(owner.archived == 1 && ownerReferrer.id != conflict.referred_by)"
                    @click="confirm({
                      id: conflict.id,
                      name: $store.getters.formatFullName(conflict.referrer.first_name, conflict.referrer.last_name),
                      type: 'reassign-repeat'
                    })"
                    href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners"><span class="icon-action_check_circle"></span><div class="label">Reassign</div></a>

                  <a
                    v-if="(owner.archived == 1 && ownerReferrer.id == conflict.referred_by)"
                    @click="confirm({
                      id: conflict.id,
                      name: $store.getters.formatFullName(conflict.referrer.first_name, conflict.referrer.last_name),
                      type: 'allow'
                    })"
                    href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners"><span class="icon-action_check_circle"></span><div class="label">Allow</div></a>
                </td>
              </tr>

            </tbody>
          </table>
        </div> <!-- dvResolve -->
      </div> <!-- dvContentMain -->

      <div class="col s12 dvContentTools">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-content">
          <!-- <a disabled href="#" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll"><span class="icon-nav_chevron_left"></span>Previous</a> -->

<!-- :class="{ disabled: (pager.currentPage < 2 || loadingConflict) ? true : false }" -->
          <a
            v-show="$route.params.referral_id == 'all'"
            :class="{ disabled: (pager.currentPage < 2 || loadingConflict) ? true : false }"
            @click="previousPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            <span class="icon-nav_chevron_left"></span>Previous
          </a>
          <!-- :class="{ disabled: !pager.hasNext || loadingConflict }" -->
          <a
            v-show="$route.params.referral_id == 'all'"
            :class="{ disabled: !pager.hasNext || loadingConflict }"
            @click="nextPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            Next<span class="icon-nav_chevron_right"></span>
          </a>
          <!-- {{ pager.hasNext }} -->
          <!-- <div class="dvContentTools-pagination">
            <input type="text" class="browser-default" placeholder="1" />
            <div class="dvContentTools-pagination-label">of 11</div>
          </div> -->


          <!-- <a href="#" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">Next<span class="icon-nav_chevron_right"></span></a> -->
        </div>
        <div class="dvContentTools-page">
          <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div>

      </div>

    </div> <!-- dvContent -->

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>

  </div>
</template>

<script>
  import MemberHeaderNav from './MemberHeaderNav.vue'
  import ProjectInq from './ProjectInq.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import ToTop from '@/components/totop/ToTop.vue'
  // import ContentLoader from '@/components/ContentLoader.vue'

  export default {
    name: 'teams-member-resolve',
    data: () => ({
      loadedCnt: 0,
      firstLoad: true,
      projects: [],
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      id: 0,
      referralSummary: [],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      team: {},
      summary: {},
      member: {},
      pager: {
        currentPage: 1,
        perPage: 3,
        hasNext: 0,
        totalRecords: 0,
        totalPages: 0,
        dataStart: 0
      },
      sortPopMenuBox: '',
      orderBy: '',
      loading: false,
      noRecordFound: false,
      pendingReferrals: [],
      resolveSelected: '',
      conflicts: [],
      owner: {},
      ownerReferrer: {},
      ownerTeam: {},
      loadingConflict: false,
      resolving: false,
      hasConflict: false
    }),
    watch: {
      loadedCnt: function() {
        if(this.id != 'all'){
          if(this.loadedCnt == 2){
            this.firstLoad = false
          }
        }else{
          this.firstLoad = false
        }
      },
      refreshImport (newPage, oldPage) {

        let allowedPages = [ 'team_member_resolve' ]
        let res = newPage.split(':');
        if(allowedPages.indexOf(res[0]) >= 0){
          if(this.id != 'all'){
            this.getMemberDetails()
          }

          if(this.$route.params.referral_id == 'all'){
            this.getPendingReferrals()
          }else{
            this.resolveSelected = this.$route.params.referral_id
            this.getPendingReferral()
          }
        }
      }
    },
    computed: {
      refreshImport  (){
        return this.$store.getters.getRefreshPage();
      }
    },
    methods: {
      getDupIndex: function(idx){
        let val = (idx + 1) - this.getTotalRepeatReg()
        if(val == 0){
          val=1
        }
        return val
      },
      getTotalRepeatReg: function(){
        let arr = this.conflicts.filter(conflict => {
          return conflict.referred_by == this.ownerReferrer.id
        })

        let retVal = 0
        if(this.owner.archived == 1){
          retVal = arr.length
        }

        return retVal
      },
      capitalize (s){
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
      },
      confirm (action){
        if(action.type == 'confirm'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to confirm this?',
            body: 'Confirming for ' + action.name,
            icon: 'icon-action_archive',
            positionBtn: 'Confirm',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'reassign'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to reassign this?',
            body: 'Reassign to '+ action.name,
            icon: 'icon-action_refresh',
            positionBtn: 'Reassign',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'deny'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to deny this?',
            body: '',
            icon: 'icon-action_delete',
            positionBtn: 'Deny',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'allow'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to allow this?',
            body: '',
            icon: 'icon-action_refresh',
            positionBtn: 'Allow',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'reassign-repeat'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to reassign this?',
            body: 'Reassign to '+ action.name,
            icon: 'icon-action_refresh',
            positionBtn: 'Reassign',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }
      },
      doConfirm (){
        this.dialog.show = false

        if(this.dialog.actionType == 'confirm'){
          this.resolveConflict(this.dialog.id, this.dialog.actionType)
        }else if(this.dialog.actionType == 'reassign'){
          this.resolveConflict(this.dialog.id, this.dialog.actionType)
        }else if(this.dialog.actionType == 'deny'){
          this.denyConflict(this.dialog.id)
        }else if(this.dialog.actionType == 'allow'){
          this.allowReassign(this.dialog.id)
        }else if(this.dialog.actionType == 'reassign-repeat'){
          this.reassignRepeat(this.dialog.id)
        }
      },
      reassignRepeat (id) {
        if(this.resolving){
          return false;
        }
        this.resolving = true
        let self = this
        this.hasConflict = false
        this.$http.secured.post('api/members/pending-referrals/resolve-repeat/'+ id)
          .then(response => {
            this.getMemberDetails()
            this.showMessage(response.data.message, 'sb-success')
            window.scroll(0, 0)

            if(this.$route.params.referral_id == 'all'){
              if(!this.pager.hasNext){
                this.pager.currentPage--
              }
              if(this.pager.currentPage == 0){
                this.noRecordFound = true
                return false
              }
              this.getPendingReferrals()
            }else{
              this.$router.push({ name:'team_member', params: { id: this.id, status: 'pending' }, query: { resolved: 'yes', msg: response.data.message } })
            }
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.resolving = false
          })
      },
      denyConflict (id) {
        if(this.resolving){
          return false;
        }
        this.resolving = true
        let self = this
        this.hasConflict = false
        this.$http.secured.post('api/members/pending-referrals/deny/'+ id)
          .then(response => {
            this.getMemberDetails()
            if(this.$route.params.referral_id == 'all'){
              if(!this.pager.hasNext){
                this.pager.currentPage--
              }
              if(this.pager.currentPage == 0){
                this.noRecordFound = true
                return false
              }
              this.getPendingReferrals()
            }else{
              this.$router.push({ name:'team_member', params: { id: this.id, status: 'pending' }, query: { resolved: 'yes', msg: response.data.message } })
            }
            this.showMessage(response.data.message, 'sb-success')
            window.scroll(0, 0)
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.resolving = false
          })
      },
      allowReassign (id) {
        if(this.resolving){
          return false;
        }
        this.resolving = true
        let self = this
        this.hasConflict = false
        this.$http.secured.post('api/members/pending-referrals/allow-reassign/'+ id)
          .then(response => {
            this.getMemberDetails()
            this.showMessage(response.data.message, 'sb-success')
            window.scroll(0, 0)

            if(this.$route.params.referral_id == 'all'){
              if(!this.pager.hasNext){
                this.pager.currentPage--
              }
              if(this.pager.currentPage == 0){
                this.noRecordFound = true
                return false
              }
              this.getPendingReferrals()
            }else{
              this.$router.push({ name:'team_member', params: { id: this.id, status: 'pending' }, query: { resolved: 'yes', msg: response.data.message } })
            }

          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.resolving = false
          })
      },
      resolveConflict (id, actionType) {
        if(this.resolving){
          return false;
        }
        this.resolving = true
        let self = this
        this.hasConflict = false
        this.$http.secured.post('api/members/pending-referrals/resolve/'+ id + '?type='+actionType)
          .then(response => {
            this.getMemberDetails()
            if(this.$route.params.referral_id == 'all'){
              if(!this.pager.hasNext){
                this.pager.currentPage--
              }
              if(this.pager.currentPage == 0){
                this.noRecordFound = true
                return false
              }
              this.getPendingReferrals()
            }else{
              this.$router.push({ name:'team_member', params: { id: this.id, status: 'pending' }, query: { resolved: 'yes', msg: response.data.message } })
            }
            this.showMessage(response.data.message, 'sb-success')
            window.scroll(0, 0)
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.resolving = false
          })
      },
      filterByReferralStatus (filterStatus){
        this.$router.push({ name: 'team_member', params: { id: this.id, status: filterStatus } })
      },
      previousPage (){
        window.scroll(0, 0)
        this.pager.currentPage--;
        // this.resolveSelected = this.pendingReferrals[this.pager.currentPage]
        this.getPendingReferrals()
      },
      nextPage (){
        window.scroll(0, 0)
        this.pager.currentPage++;
        // this.resolveSelected = this.pendingReferrals[this.pager.currentPage]
        this.getPendingReferrals()
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      hideEmptyData(){
        let officeAdd1 = this.$jQuery(".officeAdd1").children(), i = 1, hasOfficeAdd1Data = false, arrData = []

        for (i = 1; i < officeAdd1.length; i++) {
          if(this.$jQuery(officeAdd1[i]).html().length > 0){ hasOfficeAdd1Data = true}
          arrData.push(this.$jQuery(officeAdd1[i]).html())

        }
        if(!hasOfficeAdd1Data){ this.$jQuery(officeAdd1).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".officeAdd1").addClass('isDifferent')
        }

        let officeAdd2 = this.$jQuery(".officeAdd2").children(), hasOfficeAdd2Data = false
        i = 1
        arrData = []
        for (i = 1; i < officeAdd1.length; i++) {
          if(this.$jQuery(officeAdd2[i]).html().length > 0){ hasOfficeAdd2Data = true}
          arrData.push(this.$jQuery(officeAdd2[i]).html())

        }
        if(!hasOfficeAdd2Data){ this.$jQuery(officeAdd2).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".officeAdd2").addClass('isDifferent')
        }

        let officeCity = this.$jQuery(".officeCity").children(), hasOfficeCityData = false
        i = 1
        arrData = []
        for (i = 1; i < officeCity.length; i++) {
          if(this.$jQuery(officeCity[i]).html().length > 0){ hasOfficeCityData = true}
          arrData.push(this.$jQuery(officeCity[i]).html())

        }
        if(!hasOfficeCityData){ this.$jQuery(officeCity).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".officeCity").addClass('isDifferent')
        }

        let officeState = this.$jQuery(".officeState").children(), hasOfficeStateData = false
        i = 1
        arrData = []
        for (i = 1; i < officeState.length; i++) {
          if(this.$jQuery(officeState[i]).html().length > 0){ hasOfficeStateData = true}
          arrData.push(this.$jQuery(officeState[i]).html())

        }
        if(!hasOfficeStateData){ this.$jQuery(officeState).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".officeState").addClass('isDifferent')
        }

        let officeZipCode = this.$jQuery(".officeZipCode").children(), hasOfficeZipData = false
        i = 1
        arrData = []
        for (i = 1; i < officeZipCode.length; i++) {
          if(this.$jQuery(officeZipCode[i]).html().length > 0){ hasOfficeZipData = true}
          arrData.push(this.$jQuery(officeZipCode[i]).html())

        }
        if(!hasOfficeZipData){ this.$jQuery(officeZipCode).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".officeZipCode").addClass('isDifferent')
        }

        let officeCountry = this.$jQuery(".officeCountry").children(), hasOfficeCountryData = false
        i = 1
        arrData = []
        for (i = 1; i < officeCountry.length; i++) {
          if(this.$jQuery(officeCountry[i]).html().length > 0){ hasOfficeCountryData = true}
          arrData.push(this.$jQuery(officeCountry[i]).html())

        }
        if(!hasOfficeCountryData){ this.$jQuery(officeCountry).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".officeCountry").addClass('isDifferent')
        }

        if(!hasOfficeAdd1Data && !hasOfficeAdd2Data && !hasOfficeCityData && !hasOfficeStateData && !hasOfficeZipData && !hasOfficeCountryData){
          this.$jQuery('.officeAddHeader').hide()
        }









        let homeAdd1 = this.$jQuery(".homeAdd1").children(), hashomeAdd1Data = false
        i = 1
        arrData = []
        for (i = 1; i < homeAdd1.length; i++) {
          if(this.$jQuery(homeAdd1[i]).html().length > 0){ hashomeAdd1Data = true}
          arrData.push(this.$jQuery(homeAdd1[i]).html())

        }
        if(!hashomeAdd1Data){ this.$jQuery(homeAdd1).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".homeAdd1").addClass('isDifferent')
        }

        let homeAdd2 = this.$jQuery(".homeAdd2").children(), hashomeAdd2Data = false
        i = 1
        arrData = []
        for (i = 1; i < homeAdd1.length; i++) {
          if(this.$jQuery(homeAdd2[i]).html().length > 0){ hashomeAdd2Data = true}
          arrData.push(this.$jQuery(homeAdd2[i]).html())

        }
        if(!hashomeAdd2Data){ this.$jQuery(homeAdd2).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".homeAdd2").addClass('isDifferent')
        }

        let homeCity = this.$jQuery(".homeCity").children(), hashomeCityData = false
        i = 1
        arrData = []
        for (i = 1; i < homeCity.length; i++) {
          if(this.$jQuery(homeCity[i]).html().length > 0){ hashomeCityData = true}
          arrData.push(this.$jQuery(homeCity[i]).html())

        }
        if(!hashomeCityData){ this.$jQuery(homeCity).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".homeCity").addClass('isDifferent')
        }

        let homeState = this.$jQuery(".homeState").children(), hashomeStateData = false
        i = 1
        arrData = []
        for (i = 1; i < homeState.length; i++) {
          if(this.$jQuery(homeState[i]).html().length > 0){ hashomeStateData = true}
          arrData.push(this.$jQuery(homeState[i]).html())

        }
        if(!hashomeStateData){ this.$jQuery(homeState).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".homeState").addClass('isDifferent')
        }

        let homeZipCode = this.$jQuery(".homeZipCode").children(), hashomeZipData = false
        i = 1
        arrData = []
        for (i = 1; i < homeZipCode.length; i++) {
          if(this.$jQuery(homeZipCode[i]).html().length > 0){ hashomeZipData = true}
          arrData.push(this.$jQuery(homeZipCode[i]).html())

        }
        if(!hashomeZipData){ this.$jQuery(homeZipCode).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".homeZipCode").addClass('isDifferent')
        }

        let homeCountry = this.$jQuery(".homeCountry").children(), hashomeCountryData = false
        i = 1
          arrData = []
        for (i = 1; i < homeCountry.length; i++) {
          if(this.$jQuery(homeCountry[i]).html().length > 0){ hashomeCountryData = true}
          arrData.push(this.$jQuery(homeCountry[i]).html())

        }
        if(!hashomeCountryData){ this.$jQuery(homeCountry).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".homeCountry").addClass('isDifferent')
        }

        if(!hashomeAdd1Data && !hashomeAdd2Data && !hashomeCityData && !hashomeStateData && !hashomeZipData && !hashomeCountryData){
          this.$jQuery('.homeAddHeader').hide()
        }




        let lastNameHeader = this.$jQuery(".lastNameHeader").children(), hasLastNameData = false
        i = 1
        arrData = []
        for (i = 1; i < lastNameHeader.length; i++) {
          if(this.$jQuery(lastNameHeader[i]).html().length > 0){ hasLastNameData = true}
          arrData.push(this.$jQuery(lastNameHeader[i]).html())
        }

        if(!hasLastNameData){ this.$jQuery(lastNameHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".lastNameHeader").addClass('isDifferent')
        }

        let firstNameHeader = this.$jQuery(".firstNameHeader").children(), hasFirstNameData = false
        i = 1
        arrData = []
        for (i = 1; i < firstNameHeader.length; i++) {
          if(this.$jQuery(firstNameHeader[i]).html().length > 0){ hasFirstNameData = true}
          arrData.push(this.$jQuery(firstNameHeader[i]).html())
        }

        if(!hasFirstNameData){ this.$jQuery(firstNameHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".firstNameHeader").addClass('isDifferent')
        }

        let emailHeader = this.$jQuery(".emailHeader").children(), hasEmailData = false
        i = 1
        arrData = []
        for (i = 1; i < emailHeader.length; i++) {
          if(this.$jQuery(emailHeader[i]).html().length > 0){ hasEmailData = true}
          arrData.push(this.$jQuery(emailHeader[i]).html())
        }

        if(!hasEmailData){ this.$jQuery(emailHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".emailHeader").addClass('isDifferent')
        }

        let mobileHeader = this.$jQuery(".mobileHeader").children(), hasMobileData = false
        i = 1
        arrData = []
        for (i = 1; i < mobileHeader.length; i++) {
          if(this.$jQuery(mobileHeader[i]).html().length > 0 && this.$jQuery(mobileHeader[i]).html() != '<!---->'){ hasMobileData = true}
          arrData.push(this.$jQuery(mobileHeader[i]).html())
        }
        if(!hasMobileData){ this.$jQuery(mobileHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".mobileHeader").addClass('isDifferent')
        }

        let phoneHeader = this.$jQuery(".phoneHeader").children(), hasPhoneData = false
        i = 1
        arrData = []
        for (i = 1; i < phoneHeader.length; i++) {
          if(this.$jQuery(phoneHeader[i]).html().length > 0 && this.$jQuery(phoneHeader[i]).html() != '<!---->'){ hasPhoneData = true}
          arrData.push(this.$jQuery(phoneHeader[i]).html())
        }

        if(!hasPhoneData){ this.$jQuery(phoneHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".phoneHeader").addClass('isDifferent')
        }

        let bdayHeader = this.$jQuery(".bdayHeader").children(), hasBdayData = false
        i = 1
        arrData = []
        for (i = 1; i < bdayHeader.length; i++) {
          if(this.$jQuery(bdayHeader[i]).html().length > 0){ hasBdayData = true}
          arrData.push(this.$jQuery(bdayHeader[i]).html())
        }

        if(!hasBdayData){ this.$jQuery(bdayHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".bdayHeader").addClass('isDifferent')
        }

        let countryHeader = this.$jQuery(".countryHeader").children(), hasCountryData = false
        i = 1
        arrData = []
        for (i = 1; i < countryHeader.length; i++) {
          if(this.$jQuery(countryHeader[i]).html().length > 0){ hasCountryData = true}
          arrData.push(this.$jQuery(countryHeader[i]).html())
        }

        if(!hasCountryData){ this.$jQuery(countryHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".countryHeader").addClass('isDifferent')
        }




        let mothersMaindenHeader = this.$jQuery(".mothersMaindenHeader").children(), hasmothersMaindenData = false
        i = 1
        arrData = []
        for (i = 1; i < mothersMaindenHeader.length; i++) {
          if(this.$jQuery(mothersMaindenHeader[i]).html().length > 0){ hasmothersMaindenData = true}
          arrData.push(this.$jQuery(mothersMaindenHeader[i]).html())

        }
        if(!hasmothersMaindenData){ this.$jQuery(mothersMaindenHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".mothersMaindenHeader").addClass('isDifferent')
        }

        let companyNameHeader = this.$jQuery(".companyNameHeader").children(), hascompanyNameData = false
        i = 1
        arrData = []
        for (i = 1; i < companyNameHeader.length; i++) {
          if(this.$jQuery(companyNameHeader[i]).html().length > 0){ hascompanyNameData = true}
          arrData.push(this.$jQuery(companyNameHeader[i]).html())

        }
        if(!hascompanyNameData){ this.$jQuery(companyNameHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".companyNameHeader").addClass('isDifferent')
        }

        let occupationHeader = this.$jQuery(".occupationHeader").children(), hasoccupationData = false
        i = 1
        arrData = []
        for (i = 1; i < occupationHeader.length; i++) {
          if(this.$jQuery(occupationHeader[i]).html().length > 0){ hasoccupationData = true}
          arrData.push(this.$jQuery(occupationHeader[i]).html())

        }
        if(!hasoccupationData){ this.$jQuery(occupationHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".occupationHeader").addClass('isDifferent')
        }

        let civilStatHeader = this.$jQuery(".civilStatHeader").children(), hascivilStatData = false
        i = 1
        arrData = []
        for (i = 1; i < civilStatHeader.length; i++) {
          if(this.$jQuery(civilStatHeader[i]).html().length > 0){ hascivilStatData = true}
          arrData.push(this.$jQuery(civilStatHeader[i]).html())

        }
        if(!hascivilStatData){ this.$jQuery(civilStatHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".civilStatHeader").addClass('isDifferent')
        }

        let homeOwnershipHeader = this.$jQuery(".homeOwnershipHeader").children(), hashomeOwnershipData = false
        i = 1
        arrData = []
        for (i = 1; i < homeOwnershipHeader.length; i++) {
          if(this.$jQuery(homeOwnershipHeader[i]).html().length > 0){ hashomeOwnershipData = true}
          arrData.push(this.$jQuery(homeOwnershipHeader[i]).html())

        }
        if(!hashomeOwnershipData){ this.$jQuery(homeOwnershipHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".homeOwnershipHeader").addClass('isDifferent')
        }

        let monthlyIncomeHeader = this.$jQuery(".monthlyIncomeHeader").children(), hasmonthlyIncomeData = false
        i = 1
        arrData = []
        for (i = 1; i < monthlyIncomeHeader.length; i++) {
          if(this.$jQuery(monthlyIncomeHeader[i]).html().length > 0){ hasmonthlyIncomeData = true}
          arrData.push(this.$jQuery(monthlyIncomeHeader[i]).html())

        }
        if(!hasmonthlyIncomeData){ this.$jQuery(monthlyIncomeHeader).hide() }

        if(!this.hasDuplicates(arrData)){
          this.$jQuery(".monthlyIncomeHeader").addClass('isDifferent')
        }

        if(!hasmothersMaindenData && !hascompanyNameData && !hasoccupationData && !hascivilStatData && !hashomeOwnershipData && !hasmonthlyIncomeData){
          this.$jQuery('.personalInfoHeader').hide()
        }





        // let monthlyIncomeHeader = this.$jQuery(".monthlyIncomeHeader").children(), hasmonthlyIncomeData = false
        // i = 1
        // arrData = []
        // for (i = 1; i < monthlyIncomeHeader.length; i++) {
        //   if(this.$jQuery(monthlyIncomeHeader[i]).html().length > 0){ hasmonthlyIncomeData = true}
        //   arrData.push(this.$jQuery(monthlyIncomeHeader[i]).html())
        //
        // }
        // if(!hasmonthlyIncomeData){ this.$jQuery(monthlyIncomeHeader).hide() }
        //
        // if(this.hasDuplicates(arrData)){
        //   this.$jQuery(".monthlyIncomeHeader").addClass('isDifferent')
        // }
        let self = this
        Object.keys(this.projects).forEach(function (project) {

          let project_interested_in = self.$jQuery(".project_interested_in"+project).children()
          let hasProjectInteredInData = false
          arrData = []
          for (i = 1; i < project_interested_in.length; i++) {
            if(self.$jQuery(project_interested_in[i]).html().length > 0){ hasProjectInteredInData = true}
            arrData.push(self.$jQuery(project_interested_in[i]).html())
          }
          if(!hasProjectInteredInData){ self.$jQuery(project_interested_in).hide() }
          if(!self.hasDuplicates(arrData)){
            self.$jQuery(".project_interested_in"+project).addClass('isDifferent')
          }

          let location = self.$jQuery(".location"+project).children()
          let hasLocationData = false
          arrData = []
          for (i = 1; i < location.length; i++) {
            if(self.$jQuery(location[i]).html().length > 0){ hasLocationData = true}
            arrData.push(self.$jQuery(location[i]).html())
          }
          if(!hasLocationData){ self.$jQuery(location).hide() }
          if(!self.hasDuplicates(arrData)){
            self.$jQuery(".location"+project).addClass('isDifferent')
          }

          let price_range = self.$jQuery(".price_range"+project).children()
          let hasPriceRangeData = false
          arrData = []
          for (i = 1; i < price_range.length; i++) {
            if(self.$jQuery(price_range[i]).html().length > 0){ hasPriceRangeData = true}
            arrData.push(self.$jQuery(price_range[i]).html())
          }
          if(!hasPriceRangeData){ self.$jQuery(price_range).hide() }
          if(!self.hasDuplicates(arrData)){
            self.$jQuery(".price_range"+project).addClass('isDifferent')
          }

          let property_type = self.$jQuery(".property_type"+project).children()
          let hasPropertyTypeData = false
          arrData = []
          for (i = 1; i < property_type.length; i++) {
            if(self.$jQuery(property_type[i]).html().length > 0){ hasPropertyTypeData = true}
            arrData.push(self.$jQuery(property_type[i]).html())
          }
          if(!hasPropertyTypeData){ self.$jQuery(property_type).hide() }
          if(!self.hasDuplicates(arrData)){
            self.$jQuery(".property_type"+project).addClass('isDifferent')
          }

          let payment_scheme = self.$jQuery(".payment_scheme"+project).children()
          let haspaymentSchemeData = false
          arrData = []
          for (i = 1; i < payment_scheme.length; i++) {
            if(self.$jQuery(payment_scheme[i]).html().length > 0){ haspaymentSchemeData = true}
            arrData.push(self.$jQuery(payment_scheme[i]).html())
          }
          if(!haspaymentSchemeData){ self.$jQuery(payment_scheme).hide() }
          if(!self.hasDuplicates(arrData)){
            self.$jQuery(".payment_scheme"+project).addClass('isDifferent')
          }

          let primary_purpose = self.$jQuery(".primary_purpose"+project).children()
          let hasPrimaryPurposeData = false
          arrData = []
          for (i = 1; i < primary_purpose.length; i++) {
            if(self.$jQuery(primary_purpose[i]).html().length > 0){ hasPrimaryPurposeData = true}
            arrData.push(self.$jQuery(primary_purpose[i]).html())
          }
          if(!hasPrimaryPurposeData){ self.$jQuery(primary_purpose).hide() }
          if(!self.hasDuplicates(arrData)){
            self.$jQuery(".primary_purpose"+project).addClass('isDifferent')
          }
        });


      },
      onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      },
      hasDuplicates(arr){
        return arr.every( (val, i, arr) => val === arr[0] )

        // return arr.some( function(item) {
        //   return arr.indexOf(item) !== arr.lastIndexOf(item);
        // });
      },
      getPendingReferral () {
        this.loadingConflict = true
        let self = this
        this.hasConflict = false
        this.projects = []
        this.conflicts = []
        this.owner = {}
        this.ownerReferrer = {}
        this.ownerTeam = {}
        this.firstLoad = false

        this.$http.plain.get('api/members/pending-referrals/'+this.resolveSelected)
          .then(response => {
            this.conflicts = response.data

            if(this.conflicts.length == 0){
              this.noRecordFound = true
            }else{



              // Assemble projects
              let x=0, y=0

              let cntAdded = 0


              for (x = 0; x < this.conflicts.length; x++) {
                let inqs = this.conflicts[x]['project_interested_in']
                for (y = 0; y < inqs.length; y++) {

                  if(cntAdded <= y){

                    this.projects.push({
                      project_interested_in: [inqs[y].property],
                      location: [inqs[y].project_location_name],
                      price_range: [inqs[y].project_price_range_name],
                      property_type: [inqs[y].project_type_name],
                      payment_scheme: [inqs[y].payment_scheme_name],
                      primary_purpose: [inqs[y].primary_purpose_name]
                    })

                    cntAdded++
                  }else{
                    this.projects[y].project_interested_in.push(inqs[y].property)
                    this.projects[y].location.push(inqs[y].project_location_name)
                    this.projects[y].price_range.push(inqs[y].project_price_range_name)
                    this.projects[y].property_type.push(inqs[y].project_type_name)
                    this.projects[y].payment_scheme.push(inqs[y].payment_scheme_name)
                    this.projects[y].primary_purpose.push(inqs[y].primary_purpose_name)


                  }

                }
              }

              let first = this.conflicts[0]
              this.owner = first
              this.ownerReferrer = this.owner.referrer
              this.ownerTeam = this.owner.team

              this.conflicts.splice(0, 1)
              this.hasConflict = true



              setTimeout(function(){
                self.hideEmptyData()
              }, 500);

            }
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
            // self.loadingConflict = false
          })
          .then(function () {
            self.loadingConflict = false
            self.loadedCnt++
          })
      },
      getPendingReferrals () {
        if(!this.firstLoad){
          this.firstLoad = true
        }

        this.loadingConflict = true
        let self = this
        let url = 'api/members/'+this.id+'/pending-referrals?page='+this.pager.currentPage
        this.$http.plain.get(url)
          .then(response => {
            this.pendingReferrals = response.data.pendings
            if(this.pendingReferrals.length > 0){
              this.resolveSelected = this.pendingReferrals[0].pending_from

              this.pager.hasNext = response.data.has_next_page

              this.getPendingReferral()
            }else{
              this.noRecordFound = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages.error, 'sb-default')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
            //
            // this.showMessage(error, 'sb-failed')
            self.loadingConflict = false
            self.noRecordFound = true
          })
          .then(function () {
            if(self.firstLoad){
              self.firstLoad = false
            }
            self.loadedCnt++
          })
      },
      getMemberDetails () {
        if(this.loading){
          return false;
        }

        if(this.id == 'all'){
          return false;
        }

        let self = this
        this.loading = true
        this.member = {};

        this.$http.plain.get('api/members/'+this.id)
          .then(response => {
            this.team = response.data.team
            this.summary = response.data.summary
            this.member = response.data.member
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.loadedCnt++
          })
      }
    },
    mounted() {
      if(this.$getConstRole('ROLE_MANAGER') != this.$store.getters.getCurrentUserRole){
        this.$router.push({ name: 'teams' })
        return
      }

      this.id = this.$route.params.id

      if(this.id != 'all'){
        this.getMemberDetails()
      }

      if(this.$route.params.referral_id == 'all'){
        this.getPendingReferrals()
      }else{
        this.resolveSelected = this.$route.params.referral_id
        this.getPendingReferral()
      }

      // this.getReferrals()
    },
    components: {
      SnackBar,
      MemberHeaderNav,
      ConfirmationDialog,
      ProjectInq,
      BodyLoader,
      ToTop
      // ContentLoader
    }
  }
</script>
